/**
 * Maximum retry delay (60 seconds for rate-limited APIs)
 */
export const MAX_RETRY_DELAY_MS = 60000;
